// extracted by mini-css-extract-plugin
module.exports = {"chartContainer":"BarChart_chartContainer__3vTx_"};